import * as React from 'react';
import { ControllerProps } from 'src/router';
import { PaymentListController } from '../shared/payments/list/payment-list.controller';

interface Props extends ControllerProps<{}> {
}

export const AgentPaymentList: React.SFC<Props> = (props: Readonly<Props>): JSX.Element => (
	<PaymentListController
		{...props}
		type="agent"
	/>
);




// WEBPACK FOOTER //
// ./src/app/accounting/agents/agent-payment-list.tsx